import React, { useState, useEffect } from 'react';
import {
  Button,
} from 'tea-component';

import './index.scss';

interface IFilterLogicProps {
  value?: string;
  isEn?: boolean;
  onChange?: (value: string | 'AND' | 'OR') => void;
}

const FilterLogic: React.FC<IFilterLogicProps> = ({
  value,
  isEn,
  onChange
}) => {
  const [logic, setLogic] = useState(value || 'AND');

  useEffect(() => {
    setLogic(value || 'AND');
  }, [value]);

  return <div className="dbl-filter-panel-logic">
    <Button
      type={logic === 'AND' ? 'primary' : 'weak'}
      onClick={() => onChange?.('AND')}
    >
      {isEn ? 'And' : '且'}
    </Button>
    <Button
      type={logic === 'OR' ? 'primary' : 'weak'}
      onClick={() => onChange?.('OR')}
    >
      {isEn ? 'Or' : '或'}
    </Button>
    <div className='dbl-filter-panel-logic-line' />
  </div>;
};

export default FilterLogic;